import { ValidationError } from "../../errors/validation-error";
import { RealtimeRequest } from "./realtime-request";
import { IRequestByUsername } from "./request-by-username";
import { RealtimeValidator } from "./validators/realtime-validator";
import { RequestByUsernameValidator } from "./validators/request-by-username-validator";

/**
 * A request for sending real-time notifications to specified users by username.
 */
export class RealtimeRequestByUsername extends RealtimeRequest implements IRequestByUsername {
    recipients: Array<string> = [];

    validate(): void {
        const realtimeFailures = new RealtimeValidator().validate(this);
        const usernameFailures = new RequestByUsernameValidator().validate(this);

        if (realtimeFailures.length === 0 && usernameFailures.length === 0) {
            return;
        } else {
            const failures = realtimeFailures.concat(usernameFailures);
            throw new ValidationError("RealtimeRequestByUsername is invalid", ...failures);
        }
    }
}
